var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"query-material-container"},[_c('Search',_vm._b({},'Search',_vm.search,false)),_c('MTable',_vm._b({on:{"search":_vm.getTableData},scopedSlots:_vm._u([{key:"picPath",fn:function(ref){
var value = ref.value;
return [_c('el-image',{staticStyle:{"width":"100px","height":"100px"},attrs:{"src":value,"preview-src-list":[value]}})]}}])},'MTable',_vm.table,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }